import * as React from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';

/**
 * Compatibility wrapper for MUI Autocomplete.
 *
 * Material-UI v4 called `renderOption(option, state)`; v5+ calls
 * `renderOption(liProps, option, state)` and expects you to spread `liProps` onto
 * an <li>. The ported tree uses the v4 signature, so under v7 the option object was
 * actually the <li> props (e.g. `option.name` was undefined -> icon-only, no label,
 * and the <li> props/key were never applied). This wrapper detects the v4-style
 * renderOption and adapts it; everything else passes straight through.
 */
const Autocomplete = React.forwardRef<any, any>(function Autocomplete(
  { renderOption, ...props },
  ref
) {
  const adaptedRenderOption = renderOption
    ? (liProps: any, option: any, state: any) => {
        const { key, ...liRest } = liProps ?? {};
        return (
          <li key={key} {...liRest}>
            {renderOption(option, state)}
          </li>
        );
      }
    : undefined;

  // Cast: this is a passthrough shim, so required props (renderInput/options)
  // arrive via {...props} which TS can't verify against the generic component.
  const Mui = MuiAutocomplete as unknown as React.ComponentType<any>;
  return <Mui ref={ref} renderOption={adaptedRenderOption} {...props} />;
});

export default Autocomplete;
export { Autocomplete };
